import { SUPABASE } from 'drapcode-constant';
import { alertMessagesArgsConfig, browserStorageArgsConfig } from '../../utils/event_constants';

export const supabaseActions = [
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Sign Up',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Sign In via Email & Password',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Sign Out',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Fetch User',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Update User',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'authorizeWithExternalDataSource',
    label: 'Supabase: Authorize Using API',
    type: 'AUTH',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Supabase: Send Data To API',
    source: SUPABASE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsSupabase',
        value: '',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
];
